﻿import React from 'react';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import Checkbox from '../../../Forms/Components/Checkbox';

import definitions from '../../../Style/LfStyleDefinitions';
import {required} from '../../../Forms/Validation/rules';

class Step7Form extends GuideFormBase {
    render() {
        const StepForm = this.stepFormWrapper;

        return (
            <StepForm heading="Vad har du för intressen?">
                <Checkbox
                    theme="big"
                    layout="inline"
                    type="checkbox"
                    id="interests__music"
                    name="interests[0]"
                    displayname="Musik"
                    value="music"
                    checked={this.props.formData.interests.indexOf('music') > -1}
                />

                <Checkbox
                    theme="big"
                    type="checkbox"
                    id="interests__travel"
                    name="interests[1]"
                    displayname="Resor"
                    value="travel"
                    checked={this.props.formData.interests.indexOf('travel') > -1}
                />

                <Checkbox
                    theme="big"
                    type="checkbox"
                    id="interests__fitness"
                    name="interests[2]"
                    displayname="Träning & sport"
                    value="fitness"
                    checked={this.props.formData.interests.indexOf('fitness') > -1}
                />
                                                
                <Checkbox
                    theme="big"
                    type="checkbox"
                    id="interests__collecting"
                    name="interests[3]"
                    displayname="Samla på saker"
                    value="collecting"
                    checked={this.props.formData.interests.indexOf('collecting') > -1}
                />

                <Checkbox
                    theme="big"
                    layout="inline"
                    type="checkbox"
                    id="interests__culture"
                    name="interests[4]"
                    displayname="Kultur & konst"
                    value="culture"
                    checked={this.props.formData.interests.indexOf('culture') > -1}
                />

                <Checkbox
                    theme="big"
                    layout="inline"
                    type="checkbox"
                    id="interests__cooking"
                    name="interests[5]"
                    displayname="Matlagning"
                    value="cooking"
                    checked={this.props.formData.interests.indexOf('cooking') > -1}
                />
            </StepForm>
        );
    }
}

export default connectForm({ formClass: Step7Form, guideStep: 7 });